/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import Select from '../Select/index.js';
import ItemTitle from "../ItemTitle/index";

const SelectGroup = (props) => {
    const {
        itemArray,
        onChangeAction,
        onAddAction,
        onDelAction,
        addBtnText,
        questionRel,
        content,
        removeText,
        repeatMax
    } = props;

    const addAction = (event) => {
        event.preventDefault();
        event.stopPropagation && event.stopPropagation();
        event.stopImmediatePropagation && event.stopImmediatePropagation();

        onAddAction && onAddAction(questionRel);

        return false;
    };
    const deleteAction = (target) => {
        const targetIndex = Number(target.getAttribute('data-index'));
        onDelAction && onDelAction(questionRel, targetIndex)
    };
    const changeAction = (questionRel, value, event) => {
        onChangeAction && onChangeAction(questionRel, value, event)
    };
    const addBtnStatus = (repeatMax && repeatMax <= itemArray.length) ? 'none' : '';
    const questionObj = {
        questionMark: content.questionMark || null,
        question: content || {},
        questionTip: content.questionTip || null,
    };

    return (
        <div className="dynamic-group select-group">
            {content && content.title && <ItemTitle content={questionObj} />}

            {
                itemArray && itemArray.map((item, index) => {
                    return (
                        <div className="dynamic-item" key={`inputGroup_${index}`} data-key={`group_${index}`}>
                            <Select
                                content={item}
                                onChangeAction={changeAction}
                                defaultValue={item.defaultValue}
                                validationState={item.isError ? 'error' : null}
                                hasDelBtn={itemArray.length > 1 ? true : false}
                                onDelAction={deleteAction}
                                parentIndex={index}
                                removeText={removeText}
                            />
                        </div>
                    )
                })
            }
            <div className="add-btn-row" style={{ display: addBtnStatus }}>
                <Button onClick={addAction} disabled={false} data-key={`${questionRel.questionIndicator}_${addBtnText.dataKey}`}>
                    <i aria-hidden={true} className="icon icon-add">{}</i>
                    {addBtnText.text}
                </Button>
            </div>
        </div>
    )
};

SelectGroup.propTypes = {
    itemArray: PropTypes.array.isRequired,
    onChangeAction: PropTypes.func,
    onAddAction: PropTypes.func,
    onDelAction: PropTypes.func,
    addBtnText: PropTypes.object,
    questionRel: PropTypes.object,
    content: PropTypes.object,
    removeText: PropTypes.string,
    repeatMax: PropTypes.number
};

SelectGroup.defaultProps = {
    itemArray: [],
    disabled: false
};

export default SelectGroup


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/SelectGroup/index.js